import { render, staticRenderFns } from "./AdditionalOrderButton.vue?vue&type=template&id=d2b46da2&scoped=true"
import script from "./AdditionalOrderButton.vue?vue&type=script&lang=js"
export * from "./AdditionalOrderButton.vue?vue&type=script&lang=js"
import style0 from "./AdditionalOrderButton.vue?vue&type=style&index=0&id=d2b46da2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2b46da2",
  null
  
)

export default component.exports